import Common from '../../../Common';

const Field = class extends Common {
	async browse(userId: id, contactId: id) {
		return this.get(`/user/${userId}/commoncontacts/${contactId}/field)`)
	}

	async read(userId: id, contactId: id, fieldId: id) {
		return this.get(`/user/${userId}/commoncontacts/${contactId}/field/${fieldId}`)
	}

	async delete(userId: id, contactId: id, fieldId: id) {
		return this.doDelete(`/user/${userId}/commoncontacts/${contactId}/field/${fieldId}`)
	}
}

export default Field;
